<template>
  <div class="text-center">
    <v-dialog v-model="showDialog" width="800" scrollable persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="white" v-bind="attrs" v-on="on"> <v-icon left>mdi-plus</v-icon> Create Case </v-btn>
      </template>

      <v-card id="printMe">
        <v-card-title class="headline primary white--text" primary-title>Create Case</v-card-title>

        <!-- Registration forms -->
        <v-card-text v-if="registrationType">
          <CreateVisitorCaseForm v-if="showDialog && registrationType == 'TRAVELER'" ref="visitorCreationFormComponent" :formError="formError" />
          <CreateVisitorCaseLocalForm v-if="showDialog && registrationType == 'LOCAL'" ref="visitorCreationFormComponent" :formError="formError" />
        </v-card-text>

        <!-- select registration forms -->
        <v-card-text v-else>
          <h2 class="text-center my-4 title">Select registration type</h2>
          <v-row justify="center" style="min-height: 200px">
            <v-col class="py-0 pe-2 text-right text-center" cols="12" md="6">
              <v-btn x-large color="primary" dark outlined @click="registrationType = 'TRAVELER'" style="min-width: 300px">
                <v-icon left>mdi-airplane</v-icon> Traveler Registration
              </v-btn>
              <div class="title my-4">OR</div>
              <v-btn x-large color="primary" dark outlined @click="registrationType = 'LOCAL'">
                <v-icon left>mdi-map-marker</v-icon> Local Registration
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- modal buttons -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeForm()" :disabled="loadingSubmission"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="createNewSubject()"
            v-if="registrationType"
            elevation="0"
            :loading="loadingSubmission"
            :disabled="loadingSubmission"
          >
            Save
          </v-btn>
        </v-card-actions>
        <PrintCase :formDataParent="formData" :patientCase="patientCase" id="printCaseAuto" :registrationType="registrationType" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CreateVisitorCaseForm from '@/views/CreateCasePage/components/CreateCaseModal/components/CreateVisitorCaseForm.vue';
import CreateVisitorCaseLocalForm from '@/views/CreateCasePage/components/CreateCaseModal/components/CreateVisitorCaseLocalForm.vue';
import PrintCase from '@/views/CreateCasePage/components/PrintCase.vue';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      showDialog: false,
      formError: false,
      patientCase: null,
      formData: null,
      loadingSubmission: null,
      registrationType: null //LOCAL or TRAVELER
    };
  },
  components: {
    CreateVisitorCaseForm,
    CreateVisitorCaseLocalForm,
    PrintCase
  },
  watch: {
    showDialog(n) {
      if (n === false) this.registrationType = null;
    }
  },
  created() {},
  methods: {
    createNewSubject() {
      if (this.$refs.visitorCreationFormComponent.$refs['form-create-visitor-subject'].validate()) {
        this.formError = false;
        this.formData = this.$refs.visitorCreationFormComponent.formData;

        //choos action based on form type
        let action = this.registrationType == 'TRAVELER' ? 'createNewTravelerSubjectPaper' : 'createNewLocalSubjectPaper';

        //clean up
        let dataToPost = JSON.parse(JSON.stringify(this.formData));
        if (this.registrationType == 'LOCAL') {
          if (!dataToPost.azvNumber) delete dataToPost.azvNumber;
          if (!dataToPost.doctorEntry.id) delete dataToPost.doctorEntry;
          else {
            dataToPost.doctorName = this.getDoctorNameFromId(dataToPost.doctorEntry.id);
            //set doctor name on formdata so its send in the prop to the print component
            this.formData.doctorName = dataToPost.doctorName;
          }
          //registration date
          dataToPost.intoQuarantineDate = moment().local().format('YYYY-MM-DD[T]HH:mm:ss.000') + 'Z';
        }

        //register new user, action based on form type selection
        this.loadingSubmission = true;
        this.$store
          .dispatch('testTubeLinkStore/' + action, dataToPost)
          .then((data) => {
            if (data) {
              this.patientCase = data.patientCaseId;
              this.print();
              this.saveCaseCreatedToLocalStorage(dataToPost, this.patientCase, this.registrationType);
              this.$emit('caseCreated');
            }
          })
          .finally(() => {
            this.loadingSubmission = false;
          });
      } else {
        this.formError = true;
      }
    },
    closeForm() {
      this.showDialog = false;
      this.formError = false;
    },
    saveCaseCreatedToLocalStorage(caseCreated, patientCaseId, registrationType) {
      caseCreated.patientCaseId = patientCaseId;
      caseCreated.registrationType = registrationType;

      let cases = [];
      let casesSavedLocalStorage = JSON.parse(localStorage.getItem(`${this.$store.getters.appSlug}_casesCreated`));
      if (casesSavedLocalStorage) {
        cases = casesSavedLocalStorage;
        cases.unshift(caseCreated);
      } else {
        cases[0] = caseCreated;
      }

      localStorage.setItem(`${this.$store.getters.appSlug}_casesCreated`, JSON.stringify(cases.slice(0, 10)));
    },
    print() {
      this.$store.commit('SET_SHOW_LOADER', { action: true, text: 'Opening print page' });
      setTimeout(() => {
        this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
        this.$htmlToPaper('printCaseAuto', null, () => {
          let payload = {
            open: true,
            text: 'Subject created successfully',
            color: 'success'
          };
          this.$store.commit('SET_SNACKBAR', payload);
          this.showDialog = false;
        });
      }, 400);
    },
    getDoctorNameFromId(id) {
      if (this.doctorOptions.length > 0) {
        let selectedDoctor = this.doctorOptions.filter((doctor) => id == doctor.value);
        return selectedDoctor[0].text;
      }
    },
    ...mapState('testTubeLinkStore', ['doctorOptions'])
  }
};
</script>

<style>
</style>